import { Badge, type BadgeProps } from "@atlas/core";
import type { ReactElement } from "react";

type HubCatalogTypeBadgeVariant = "intelligence";

export interface IHubCatalogTypeBadge {
  id: string;
  label: string;
  variant: HubCatalogTypeBadgeVariant;
  appearance: BadgeProps["appearance"];
  size: BadgeProps["size"];
}

export function resolveHubCatalogTypeBadge(
  catalogTypeLabel?: string | null,
): IHubCatalogTypeBadge | null {
  const label = (catalogTypeLabel ?? "").trim();
  if (!label) return null;

  return {
    id: "catalogType",
    label,
    variant: "intelligence",
    appearance: "light",
    size: "sm",
  };
}

type HubCatalogTypeBadgeElementProps = Omit<BadgeProps, "children" | "variant">;

export function getHubCatalogTypeBadge(
  catalogTypeLabel?: string | null,
  badgeProps?: HubCatalogTypeBadgeElementProps,
): ReactElement | null {
  const meta = resolveHubCatalogTypeBadge(catalogTypeLabel);
  if (!meta) return null;
  return (
    <Badge
      size={meta.size}
      appearance={meta.appearance}
      variant={meta.variant}
      {...badgeProps}>
      {meta.label}
    </Badge>
  );
}
